module.exports = __webpack_public_path__ + "img/ic_arrow_left_red.b4a822bf.svg";